<p-tabs styleClass="update-panel" [value]="activeIndex">
  <p-tablist>
    <p-tab [value]="0">Activity</p-tab>
    <p-tab [value]="1">Pinned</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <div #updatesContainer class="mb-auto scrol-bx">
        <div *ngFor="let updates of workflowUpdatesList">
          <div class="update-txt globalborder-btm-header pt-1 pb-1">
            <div>
              <label [innerHTML]="updates.message"></label>
            </div>
            <div class="fonts-12 d-flex justify-content-between">
              <label class="font-weight-light">{{
                updates.createdDate | date: "HH:mm:ss MMMM dd,yyyy"
              }}</label>
              <label class="font-weight-light"
                >By {{ updates.createdBy }}</label
              >
              <div class="form-check mb-0 pb-0">
                <label class="custom-checkbox d-flex gap-1 align-items-end">
                  <!-- <input
                    pInputText
                    class="form-check-input"
                    (change)="onChecked($event, updates.recordId)"
                    [checked]="updates.pinned"
                    type="checkbox" /> -->
                  <p-checkBox
                    [inputId]="'pin' + updates.recordId"
                    (onChange)="onChecked($event, updates.recordId)"
                    [binary]="true"
                    [ngModel]="updates.pinned"
                    styleClass="custom-pin-checkbox">
                    <ng-template pTemplate="icon" let-checked="checked">
                      <!-- <i class="pi" [ngClass]="checked ? 'pi-thumbtack' : 'pi-thumbtack'"></i> -->
                      <span [ngClass]="checked ? 'fillsvg' : 'unfilledsvg'">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-pin-fill"
                          viewBox="0 0 16 16">
                          <path
                            d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354" />
                        </svg>
                      </span>
                    </ng-template>
                  </p-checkBox>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabpanel>
    <p-tabpanel [value]="1">
      <div class="mb-auto scrol-bx">
        <div *ngFor="let updates of workflowUpdatesPinnedList">
          <div class="update-txt globalborder-btm-header pt-1 pb-1">
            <div class="mt-1 mb-1">
              <label [innerHTML]="updates.message"></label>
            </div>
            <div class="fonts-12 d-flex justify-content-between">
              <label class="font-weight-light">{{
                updates.createdDate | date: "HH:mm:ss MMMM dd,yyyy"
              }}</label>
              <label class="font-weight-light"
                >By {{ updates.createdBy }}</label
              >
              <div class="form-check">
                <label class="custom-checkbox d-flex gap-1 align-items-end">
                  <!-- <input
                    pInputText
                    class="form-check-input"
                    (change)="onChecked($event, updates.recordId)"
                    [checked]="updates.pinned"
                    type="checkbox" /> -->
                  <p-checkBox
                    [inputId]="'pin' + updates.recordId"
                    (onChange)="onChecked($event, updates.recordId)"
                    [binary]="true"
                    [ngModel]="updates.pinned"
                    styleClass="custom-pin-checkbox">
                    <ng-template pTemplate="icon" let-checked="checked">
                      <!-- <i class="pi" [ngClass]="checked ? 'pi-thumbtack' : 'pi-thumbtack'"></i> -->
                      <span [ngClass]="checked ? 'fillsvg' : ''">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-pin-fill"
                          viewBox="0 0 16 16">
                          <path
                            d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354" />
                        </svg>
                      </span>
                    </ng-template>
                  </p-checkBox>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
<div class="form-group mt-2">
  <textarea
    pTextarea
    cols="30"
    rows="10"
    placeholder="Post updates here"
    (change)="onValueChange()"
    [(ngModel)]="update"></textarea>
</div>
<div style="text-align: right">
  <!-- <p-button
    [disabled]="isDisableLink"
    type="button"
    class="btn btn-secondary"
    (click)="postWorkflowUpdate()">
    Post
  </p-button> -->

  <p-button
    label="Post"
    [disabled]="isDisableLink"
    (click)="postWorkflowUpdate()" />
</div>
